const isEntitlementDojo = (entitlement) =>
  entitlement && entitlement.application === 'OnlineTraining'

export default isEntitlementDojo
